import React from "react";
import Footer from "../../Footer/js/Footer";
import Header from "../../Header/js/Header";
import ServicesHero from "./ServicesHero";
import ServicesWB from "./ServicesWB";
import Showcase from "../../Showcase/js/Showcase";
import MoreServices from "./MoreServices";
import servicesSeed from "../data/services";
import useContent from "../../hooks/useContent";

function Services() {
  const items = useContent("services", servicesSeed);
  return (
    <div className="Services">
      <Header />
      <ServicesHero />
      <ServicesWB />
      <Showcase items={items} />
      <MoreServices />
      <Footer />
    </div>
  );
}

export default Services;
